// employees/EmployeeContext.js
import React, { createContext, useContext, useState, useMemo, useEffect, useCallback } from 'react';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import {getAllDocumentApi, getAllDocumentTypeApi} from "api/services/documents"
import { useSearchParams, useParams } from 'react-router-dom';
import useDocumentFilter from "../hooks/filterHook"
import {  useNavigate } from "react-router-dom";
import {format} from "date-fns"
import { filterHandler } from 'utils/common';
import { useMediaQuery } from "react-responsive";


							
									  

// Create the Document context
const documentContext = createContext();

// Custom hook for accessing Document context easily
export const useDocument = () => {
  return useContext(documentContext); 
};

// DocumentProvider component to wrap around components needing access to Resume data
export const DocumentProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    let params = useParams()
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const navigate = useNavigate()

  
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   
  const [documentModal, setDocumentModal] = useState(false);
  const [ selectedDocument, setSelectedDocument] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [view, setView] = useState(isMobile? "grid":"list");
  const [storeType, setStoreType] = useState(window.location.pathname.includes("store") ? "store" : "user");

  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [documentType, setDocumentType] = useState([])
  const [documentTypeLoading, setDocumentTypeLoading] = useState(false)

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_by") || "",
    document_type: searchParams.get("document_type") ,
    // document_sub_type: searchParams.get("document_sub_type") ,
    user: searchParams.get("company_user")

    //document_type=user&document_sub_type=passport&user=1&issue_date_after=2025-10-28&issue_date_before=2025-10-29&expiry_date_after=2025-10-30&expiry_date_before=2025-10-30&sort_type=ascend&sort_by=issue_date&expiry_in=365
})
const { handleFilterChange,
    filters,
    handleInputChange, filterLoading, setFilterLoading, handleDateChange} = useDocumentFilter(pageSettings , setPageSettings);

const getFilterParams = useCallback(()=>{
  let filter_params = filterHandler(filters)
    return filter_params
        
})

const setDocumentParams = (pageData) => {
    let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        ...filter_params
    }
    setSearchParams(params)
}



    const getDocumentList = () => {
        setLoading(true)
        setFilterLoading(true)      
        let filter_params = getFilterParams()
          if(filter_params?.issue_date_after){
            filter_params.issue_date_after = format(new Date(filter_params.issue_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.issue_date_before){
          filter_params.issue_date_before = format(new Date(filter_params.issue_date_before), "yyyy-MM-dd")
         }

        if(filter_params?.expiry_date_after){
            filter_params.expiry_date_after = format(new Date(filter_params.expiry_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.expiry_date_before){
            filter_params.expiry_date_before = format(new Date(filter_params.expiry_date_before), "yyyy-MM-dd")
        }


          
        getAllDocumentApi({         
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          employee: pageSettings?.employee,
          document_type: pageSettings?.document_type,
          document_sub_type: pageSettings?.document_sub_type,
          company_user: pageSettings?.userData,
          document_type__type: storeType,
          ...filter_params    
        }).then(response=>{
          if(view=="grid" && pageSettings?.page!==1){
            setDocumentData([...documentData,...response.data.results]);

          }else{
            setDocumentData(response.data.results);

          }

          
          setPageSettings({
            ...pageSettings,
            total: response.data.count
          })
    
          setLoading(false)
          setFilterLoading(false)
          setShowFilterDrawer(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{

    console.log(window.location.pathname, "#########")
    getDocumentList()

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters, storeType])

  useEffect(()=>{
    setDocumentParams(pageSettings)
  },[pageSettings])

  useEffect(()=>{
    setDocumentTypeLoading(true)
    getAllDocumentTypeApi({type:storeType}).then(response=>{
      setDocumentType(response.data.results)
      setDocumentTypeLoading(false)
    }).catch(e=>{
      setDocumentTypeLoading(false)
    })
  },[storeType])

  const handleApplyFilter = () => {
    setPageSettings({
        ...pageSettings,
        page: 1,
        filters
      })

  }


  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })				 
			 
	
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    setPageSettings(pageData)
  }; 
							
		
  

  const handleFilterDrawer = () => {
    console.log("JJJJJJJ")
    setShowFilterDrawer(!showFilterDrawer)
    setFilterLoading(false)
  }



  const handleDocumentDetailPage = (id, index) => {			  
    navigate(`/documents/${id}`)
    setSelectedPage(index)
  }



  const resetDocumentList = () => {
    console.log("*****************")
    setDocumentData([])
    setPageSettings({
      ...pageSettings,
      ...defaultPagination,
      page: searchParams.get("page") || 1,
      pageSize: searchParams.get("size") || 50,
      sortType: searchParams.get("sort_type") || "",
      sortBy: searchParams.get("sort_by") || "",
      document_type: searchParams.get("document_type") ,
      // document_sub_type: searchParams.get("document_sub_type") ,
      user: searchParams.get("company_user")
      
    })
  }
  // Value to be provided to context consumers
  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    documentData, setDocumentData,
    loading, setLoading,
   
    view, setView,
    pageSettings , setPageSettings,
    showFilterDrawer, setShowFilterDrawer,

    filterLoading, setFilterLoading,
    selectedPage, setSelectedPage,

    documentModal, setDocumentModal,
    selectedDocument, setSelectedDocument,

    handleGridChange,
    handleChange,

    handleFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    handleDocumentDetailPage,
    handleDateChange,
    getDocumentList,

    documentType, setDocumentType,
    storeType, setStoreType,
    documentTypeLoading,

    resetDocumentList
    
  }), [documentData , view, loading, pageSettings, showFilterDrawer, filters, filterLoading, selectedPage, documentModal, selectedDocument, documentType, storeType, documentTypeLoading]);

  return (
    <documentContext.Provider value={value}>
      {children}
    </documentContext.Provider>
  );
};